// extracted by mini-css-extract-plugin
export default {"root":"UserInfoView_root__j49Gg","wrapper":"UserInfoView_wrapper__rEZwP","warning":"UserInfoView_warning__Cmc1O","warningTitle":"UserInfoView_warningTitle__Y6Bdi"};